import axios from 'axios'

const state = {
    salesRules: null,
    ruleResults: null,
}

const getters = {
    salesRules (state) {
        return state.salesRules
    },
    ruleResults (state) {
        return state.ruleResults
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    // new sales rule
    async createSale({ dispatch }, salesObj) {
        let response = await axios.post('/sales/newSale', salesObj)
        if(!response.data.error){
            dispatch('fetchSalesRules') 
        }
        return response.data
    },

    // fetch sales rule
    async fetchSalesRules({ commit, getters }) {
        let userId = getters.user._id
        let response = await axios.get(`/sales/myRules/${userId}`)
        if(!response.data.error){
            return commit('SALES_RULES', response.data.result) 
        }
        return response.data
    },

    // apply sales rule
    async applySalesRule({ dispatch }, ruleObj) {
        let response = await axios.post('/sales/applyRule', ruleObj)
        if(!response.data.error){
            dispatch('fetchSalesRules') 
        }
        return response.data
    },
    
    // fetch rule results
    async fetchRuleResults({ commit }, ruleObj) {
        let response = await axios.post('/sales/ruleResults', ruleObj)
        if(!response.data.error){
            commit('RULE_RESULTS', response.data.result)
        }
        return response.data
    },
    
    // end sales rule
    async endSalesRule({ dispatch }, ruleObj) {
        let response = await axios.post('/sales/endRule', ruleObj)
        if(!response.data.error){
            dispatch('fetchSalesRules') 
        }
        return response.data
    },
    
    // delete sales rule
    async deleteSalesRule({ dispatch }, ruleObj) {
        let response = await axios.post('/sales/deleteRule', ruleObj)
        if(!response.data.error){
            dispatch('fetchSalesRules') 
        }
        return response.data
    },
    
    // remove sales items
    async removeSaleItem({ dispatch }, ruleObj) {
        let response = await axios.post('/sales/removeItem', ruleObj)
        if(!response.data.error){
            dispatch('fetchRuleResults', ruleObj) 
        }
        return response.data
    },

}

const mutations = {
    SALES_RULES: (state, salesRules) => (state.salesRules = salesRules),
    RULE_RESULTS: (state, ruleResults) => (state.ruleResults = ruleResults),
}

export default {
    state,
    getters,
    actions,
    mutations
}